<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-05-06 09:48:42
 * @LastEditTime: 2026-06-04 09:36:51
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 超合同审批
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\supplyManagement\contractPerformance\ExceedContractApproval.vue
-->
<template>
    <div class="flows-content">
        <el-container>
            <el-main style="margin-bottom: 20px; padding: 0;">
                <el-container direction="vertical">
                    <FlowHeader :isReadOnly="readOnly" :saveStatus="false" @saveSubmit="handleSubmit(1)"
                        @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)"
                        @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)"
                        @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)"
                        @handleCollection="handleSubmit(10)" />
                    <el-main class="info">
                        <div>
                            <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                                placeholder="请输入流程标题"></el-input>
                        </div>
                        <div class="info-top">
                            <div class="left">
                                <span>单据号码：{{ billCode }}</span>
                                <span class="text">制单日期：{{ billDate }}</span>
                            </div>
                            <div class="right">
                                <span>发起人：{{ applyPerson }}</span>
                                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
                            </div>
                        </div>
                        <div style="margin-top:20px;" class="table">
                            <el-descriptions :column="2" border class="descriptions" label-width="200">
                                <el-descriptions-item label="申请日期：" >{{ formData.createTime }}</el-descriptions-item>
                                <el-descriptions-item label="工程名称：">{{ formData.projectName }}</el-descriptions-item>
                                <el-descriptions-item label="工程ID：">{{ formData.projectId }}</el-descriptions-item>
                                <el-descriptions-item label="合同单位：">{{formData.contractCompany}}</el-descriptions-item>
                                <el-descriptions-item label="施工进度">{{ formData.supplyPhase }}</el-descriptions-item>
                                <el-descriptions-item label="交底类型：">{{ formData.discloseType }}</el-descriptions-item>
                                <el-descriptions-item label="签订主体：">{{ formData.signCompany }}</el-descriptions-item>
                                <el-descriptions-item label="销售员：">{{ formData.salePerson }}</el-descriptions-item>
                                <el-descriptions-item label="最近一次供应时间：">{{ formData.lastSupplyTime }}</el-descriptions-item>
                                <el-descriptions-item label="合同量：">{{ formData.contractQuantity }}</el-descriptions-item>
                                <el-descriptions-item label="累计供应量（m³）">{{ formData.totalSupplyQuantity }}</el-descriptions-item>
                                <el-descriptions-item label="本次申请累计供应量（m³）">
                                    <el-input v-model="formData.controlQuantity" placeholder="请输入"  style="width: 430px;" disabled> </el-input>
                                </el-descriptions-item>
                                <el-descriptions-item label="原因概述" labelClassName="redFont" contentClassName="textClass"
                                    :span="2">
                                    <el-input v-model="formData.alterReason" placeholder="请输入" type="textarea" disabled
                                        style="width: 100%;">
                                    </el-input>
                                </el-descriptions-item>
                                <!-- <el-descriptions-item label="附件：" :span="2">
                                    <FileComponent fileCode="settlementFile" :disabled="true" :files="files" />
                                </el-descriptions-item> -->
                            </el-descriptions>
                            <!-- 项目明细表格 -->
                            <template v-if="subProjectInfoTableData && subProjectInfoTableData.length > 0">
                                <el-table
                                    :header-cell-style="{ background: '#f3f6f9' }"
                                    :cell-style="{ borderRight: 'none' }"
                                    border
                                    stripe
                                    style="width: 100%; margin-top: 12px;"
                                    :data="subProjectInfoTableData"
                                >
                                    <el-table-column label="工程id" align="center" prop="projectId" width="auto"></el-table-column>
                                    <el-table-column label="工程名称" align="center" prop="projectName" width="auto"></el-table-column>
                                    <el-table-column label="累计供应量（m³）" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                                </el-table>
                            </template>
                            <span v-if="taskType != 1" style="font-size: 18px">领导审批参数</span>
                            <el-button v-if="taskType != 1" style="margin-left: 24px" size="medium"
                                :class="confirmStatus ? 'bottom_all' : 'bottom_two'" @click="confirmStatus = true">{{
                                    confirmStatus ? '已确认' : '请确认' }}</el-button>
                            <el-descriptions v-if="taskType != 1" :column="2" border class="descriptions" label-width="200"
                                style="margin-bottom: 24px;margin-top:12px">
                                <el-descriptions-item label="本次申请累计供应量（m³）" labelClassName="redFont">
                                    <el-input v-model="formData.alterValue" placeholder="请输入" :disabled="confirmStatus"  style="width: 430px;" ></el-input>
                                </el-descriptions-item>
                            </el-descriptions>
                            <span style="font-size: 18px">历史申请流程</span>
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%;margin-top: 12px;" tooltip-effect="dark " :data="removeControlTableData">
                                <el-table-column label="申请时间" align="center" prop="updateTime" width="auto"></el-table-column>
                                <el-table-column label="申请人" align="center" prop="updateUserName" width="auto"></el-table-column>
                                <el-table-column label="合同量" align="center" prop="contractQuantity" width="auto"></el-table-column>
                                <el-table-column label="累计供应量" align="center" prop="totalSupplyQuantity" width="auto"></el-table-column>
                                <el-table-column label="本次申请累计合同量" align="center" prop="controlQuantity" width="auto"></el-table-column>
                                <el-table-column label="流程完成时间" align="center" prop="approveTime" width="auto"></el-table-column>
                                <el-table-column label="审批状态" align="center" prop="approveStatus" width="auto">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.approveStatus == 0">撤销</span>
                                        <span v-else-if="scope.row.approveStatus == 1">审批中</span>
                                        <span v-else-if="scope.row.approveStatus == 2">审批通过</span>
                                        <span v-else-if="scope.row.approveStatus == 3">审核失败</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="left" width="90">
                                    <template slot-scope="scope">
                                        <el-button size="mini" class="bottom_two" @click="lookDetail(scope.row)">
                                            查看
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="flows-details">
                            <FlowContent ref="flowcontent" :title='title' :dataForm="formData"
                                :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode"
                                @sendProcessManagerId="sendProcessManagerId" @sendProcessVersionId="sendProcessVersionId"
                                @handleFinish="handleFinish" @handleBusiness="handleBusiness"
                                @resetFlowState="resetFlowState" />
                        </div>
                    </el-main>
                </el-container>
                <!-- 历史记录明细 -->
                <el-dialog :visible.sync="historyDetailDig" width="1080px" :close-on-click-modal="false">
                    <span slot="title" class="dialog-title">申请解控</span>
                    <el-descriptions :column="2" border class="descriptions" label-width="200">
                        <el-descriptions-item label="申请日期：" >{{ historyDetailForm.createTime }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称：">{{ historyDetailForm.projectName }}</el-descriptions-item>
                        <el-descriptions-item label="工程ID：">{{ historyDetailForm.projectId }}</el-descriptions-item>
                        <el-descriptions-item label="合同单位：">{{historyDetailForm.contractCompany}}</el-descriptions-item>
                        <el-descriptions-item label="施工进度">{{ historyDetailForm.supplyPhase }}</el-descriptions-item>
                        <el-descriptions-item label="交底类型：">{{ historyDetailForm.discloseType }}</el-descriptions-item>
                        <el-descriptions-item label="签订主体：">{{ historyDetailForm.signCompany }}</el-descriptions-item>
                        <el-descriptions-item label="销售员：">{{ historyDetailForm.salePerson }}</el-descriptions-item>
                        <el-descriptions-item label="最近一次供应时间：">{{ historyDetailForm.lastSupplyTime }}</el-descriptions-item>
                        <el-descriptions-item label="合同量：">{{ historyDetailForm.contractQuantity }}</el-descriptions-item>
                        <el-descriptions-item label="累计供应量（m³）">{{ historyDetailForm.totalSupplyQuantity }}</el-descriptions-item>
                        <el-descriptions-item label="本次申请累计供应量（m³）">{{ historyDetailForm.controlQuantity }}</el-descriptions-item>
                        <el-descriptions-item label="原因概述" labelClassName="redFont" contentClassName="textClass"
                            :span="2">
                            <el-input v-model="historyDetailForm.alterReason" :disabled="true" placeholder="请输入" type="textarea"
                                style="width: 100%;">
                            </el-input>
                        </el-descriptions-item>
                            <!-- <el-descriptions-item label="附件：" :span="2">
                                <FileComponent fileCode="settlementFile" :disabled="true" :files="files2" />
                            </el-descriptions-item> -->
                        </el-descriptions>
                    <span style="font-size: 18px">领导审批参数</span>
                    <el-descriptions :column="2" border class="descriptions" label-width="200" style="margin-bottom: 24px;">
                        <el-descriptions-item label="本次申请累计供应量（m³）" labelClassName="redFont">
                            {{ historyDetailForm.alterValue }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <FlowsNodeList :tableData="approveTableData" />
                    <span slot="footer" class="dialog-footer">
                        <el-button class="bottom_all_two" @click="historyDetailDig = false">关 闭</el-button>
                    </span>
                </el-dialog>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { ExceedContractUpdateHistory, ExceedContractSubmitApproval, ExceedContractApprovalHandle, ExceedContractGetHistoryData, } from "@/api/internetSales/supplyManagement.js";
// import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { getNodeList } from '@/api/task/flows';
import { backlogQueryByReceiptNumber } from '@/api/index';
import { safeDecodeURI } from "@/utils/utils.js";
import FlowsNodeList from '@/components/WorkFlow/flowsNodeList';
export default {
    components: {
        FlowContent,
        FlowHeader,
        // FileComponent,
        FlowsNodeList
    },
    data() {
        return {
            type: 0,
            title: '解控申请单',
            billCode: '',
            billDate: '',
            taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
            applyPerson: '',
            taskStatus: 0,
            showSendVisible: false,
            readOnly: false,
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "80", fixed: "left", },
                { label: "财务编码", prop: "financialCode", status: true, width: "220", fixed: "left", },
                { label: "工程名称", prop: "projectName", status: true, width: "280", fixed: "left", },
                { label: "合同单位", prop: "contractUnit", status: true, width: "220" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "本期项目产值", prop: "currentProjectOutputValue", status: true, width: "100" },
                { label: "本期合同应收款", prop: "currentContractReceivables", status: true, width: "110" },
                { label: "本期累计回款", prop: "currentCumulativePaymentReceived", status: true, width: "100" },
                { label: "本期工程欠款", prop: "currentEngineeringArrears", status: true, width: "100" },
                { label: "本期合同欠款", prop: "currentContractArrears", status: true, width: "100" },
                { label: "上期合同应收款", prop: "lastContractReceivables", status: true, width: "100" },
                { label: "实时累计回款", prop: "realTimeCumulativeReal", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "deviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "contractArrearsAbsValue", status: true, width: "auto" },
                { label: "欠款管控等级", prop: "debtControlLevel", status: true, width: "auto" },
            ],
            formData: {},
            tableData: [],
            total: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                projectName: "",
                reviewId: "",
                whetherControl: 1,
            },
            files: [],
            historyDetailDig: false,
            historyDetailForm: {},
            files2: [],
            files4: [],
            processManagerId: "",
            processVersionId: "",
            processTaskId: "",
            approveTableData: [],
            removeControlTableData: [],
            subProjectInfoTableData: [],
            taskType: 1,
            confirmStatus: false,
        }
    },
    methods: {
        sendProcessManagerId(processManagerId) {
            this.processManagerId = processManagerId;
        },
        sendProcessVersionId(processVersionId) {
            console.log(processVersionId)
            this.processVersionId = processVersionId;
            console.log("processVersionId-----------------------" + processVersionId)
        },
        lookDetail(row) {
            console.log(row)
            this.historyDetailForm = row
            this.files2 = this.historyDetailForm.attachment ? JSON.parse(this.historyDetailForm.attachment) : []
            // 获取所有节点
            let params = {
                processManagerId: row.processManagerId,
                processTaskId: row.processTaskId,
                processVersionId: row.processVersionId
            }
            getNodeList(params).then(res => {
                if (res.code === 1001) {
                    const newData = [];
                    res.data.forEach(item => {
                        const data = {
                            nodeName: item.nodeName,
                            userName: item.instanceLogsList.map(sItem => sItem.userName),
                            userId: item.instanceLogsList.map(sItem => sItem.userId),
                            multiApprovalType: item.multiApprovalType,
                            approvalOptions: item.instanceLogsList.map(sItem => sItem.approvalOptions),
                            handlerTime: item.instanceLogsList.map(sItem => sItem.handlerTime),
                            id: item.id,
                            approveStatus: item.approveStatus,
                            processInstanceId: item.processInstanceId,
                            processInstanceNodeId: item.instanceLogsList.map(sItem => sItem.processInstanceNodeId),
                        }
                        newData.push(data);
                    });
                    this.approveTableData = newData;

                }
            });
            this.historyDetailDig = true
        },
        ExceedContractUpdateHistory() {
            console.log("12121212")
            console.log(this.formData)
            let obj = {
                id: this.formData.id,
                alterValue: this.formData.alterValue,
                alterReason: this.formData.alterReason,
            }
            ExceedContractUpdateHistory(obj)
        },
        //1 不通过  2撤销
        resetFlowState(type) {
            if (type == 1) {
                const params = {
                    process_success: {
                        url: '/icps/exceedContract/applyDecontrolResult',
                        data: {
                            id: this.formData.id,
                            approveStatus: 2,
                        },
                        httpMethod: 'post',
                    },
                    process_failure: {
                        url: '/icps/exceedContract/applyDecontrolResult',
                        data: {
                            id: this.formData.id,
                            approveStatus: 3,
                        },
                        httpMethod: 'post',
                    },
                }
                this.$refs.flowcontent.handleToFlow(params);
            }
            if (type == 2) {
                ExceedContractApprovalHandle({
                    id: this.formData.id,
                    approveStatus: 0,
                })
            }

            this.showSendVisible = false;
        },
        async handleBusiness() { 
                ExceedContractUpdateHistory({
                    id: this.formData.id,
                    alterValue: this.formData.alterValue,
                    alterReason: this.formData.alterReason,
                }).then(res => {
                    if(res.code == 1001) {
                        this.handleToFlow()
                    }
                })
        },
        handleToFlow(){
            const params = {
                process_success: {
                    url: '/icps/exceedContract/applyDecontrolResult',
                    data: {
                        id: this.formData.id,
                        approveStatus: 2,
                    },
                    httpMethod: 'post',
                },
                process_failure: {
                    url: '/icps/exceedContract/applyDecontrolResult',
                    data: {
                        id: this.formData.id,
                        approveStatus: 3,

                    },
                    httpMethod: 'post',
                },
            }
            this.showSendVisible = false;
            this.$refs.flowcontent.handleToFlow(params);
        },
        /**
         * @Description: 
         * @Param: 1为保存时 status 为 processTaskId，2为最后提交/3 中间提交 时 status 为2 通过 为3不通过
         * @Author: wangwangwang
         * @param {*} type
         */
        handleFinish(type, status) {
            console.log(type, status)
            //审批过程中修改数据
            if (type == 1) {
                this.formData.processManagerId = this.processManagerId,
                this.formData.processTaskId = status,
                this.formData.processVersionId = this.processVersionId,
                this.formData.receiptNumber = this.billCode,
                this.formData.approveStatus = 1, //修改审批中
                console.log("--------------------232323----------------")
                console.log(this.formData)
                // this.formData.alterValue = this.formData.controlQuantity;
                ExceedContractSubmitApproval(this.formData).then(res => {
                    if (res.code == 1001) {
                        this.$message.warning('提交成功！')
                    }
                })

            }

        },
        async handleSubmit(type) {
            if (this.taskType != 1 && !this.confirmStatus && type == 2) {
                this.$message.warning('请确认领导审批参数!')
                return
            }
            // if (this.taskType != 1 && type == 2) {

            // }
            const { query } = this.$route;
            if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 提交流程
                this.showSendVisible = true;
                setTimeout(() => {
                    let approvalOptions = "本次申请累计供应量（m³）：:" + this.formData.alterValue
                    this.$refs.flowcontent.setOperationModal(approvalOptions)
                }, 200)
                return
            }
            const data = {
                dataSource: 'ExceedContractApproval',
                dataContent: JSON.stringify({ ...this.formData }), // 业务数据
            }

            this.$refs.flowcontent.saveFlows(type, data);
        },
        handleCancel() {
            this.showSendVisible = false;
        },
        /**
         * @Description: 回显业务数据
         * @Param: 
         * @Author: wangwangwang
         */
        initFlowsData() {
            this.isReadOnly = true;
            const { query } = this.$route;
            console.log("initFlowsData2", query);
            // const { formData} = query;
            const data = JSON.parse(query.dataContent);
            console.log("🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ data:", data)
            this.formData = data;
            this.formData.alterValue = this.formData.controlQuantity
           
            // this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
        },
        initFlowsData2() {
            const { query } = this.$route;
            this.formData = safeDecodeURI(JSON.parse(query.dataContent));
            this.title = query.taskName;
            this.billCode = query.receiptNumber;
            this.applyPerson = query.createUserName;
            this.billDate = query.createTime;
            this.taskStatus = query.taskStatus;
            // this.files = this.formData.attachment ? JSON.parse(this.formData.attachment) : []
            ExceedContractGetHistoryData(this.formData.id).then(res => {
                if (res.code == 1001) {
                    this.formData = res.data
                    this.removeControlTableData = res.data.exceedContractProjectHistoryList
                    this.subProjectInfoTableData =  res.data.subProjectInfo ? JSON.parse(res.data.subProjectInfo) : []
                }
            })
            this.openWorkFlowInfo()
        },
        sendCode(code)    {
            this.billCode = code;
        },
        handleFlowChat() {
            this.$refs.flowcontent.showFlowNode()
        },
        // 查看审批情况
        openWorkFlowInfo() {
            console.log('查看审批情况 ', this.billCode)
            if (this.billCode) {
                backlogQueryByReceiptNumber(this.billCode).then(res => {
                    if (res.code == 1001) {
                        if (res.data) {
                            let valData = res.data
                            this.taskStatus = valData.taskStatus
                            this.applyPerson = valData.createUserName
                            this.billDate = valData.createTime
                            if (this.taskStatus == 3 || this.taskStatus == 4 || this.taskStatus == 5) {
                                this.readOnly = true
                            }
                        }
                    }
                })
            }
        },
    },
    mounted() {
        const { query } = this.$route;
        this.taskType = query.type
        if (query.type == 1) {
            // 发起流程
            this.initFlowsData();
            this.title = '超合同流程管控审核-' + this.formData.projectName
            this.applyPerson = getUserInfo().userRealName;
            this.$refs.flowcontent.initBaseData("ExceedContractApproval");
            this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
            this.formData.createUserName = this.applyPerson;
            this.formData.createTime = this.billDate;
            return;
        }
        this.initFlowsData2();
        if (query.isReadOnly * 1 === 1) {
            this.readOnly = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.flows-details {
    margin-top: 20px;
}

.info {
    padding: 0 20px;
    background: #fff;

    .info-top {
        font-size: $font_size;
        color: #000000;
        @include discen_al;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px #e1e5ed solid;

        .left {
            @include discen_al;
        }

        .text {
            margin-left: 60px;
        }
    }
}

.nav_title {
    @include discen_al;
    align-items: flex-end;

    >div {
        width: 4px;
        height: 24px;
        background: $bg_color;
        margin-right: 10px;
    }

    i {
        margin-left: 5px;
    }

    color: $bg_color;
    font-size: 20px;
    font-weight: bold;
}
</style>
<style scoped>
.descriptions>>>.redFont {
    color: red !important;
}

.descriptions>>>.textClass {
    width: 450px;
}

.descriptions>>>.textClass2 {
    width: 300px;
}
</style>